import React from 'react';
import { MyLocation } from '@styled-icons/material/MyLocation';
import { UserInteraction, UserInteractionVariant } from '@naf/user-interaction';
import * as S from './NafCenters.styles';

interface LocationSortButtonProps {
  onClick: () => void;
  isLoading: boolean;
  error: string | null;
  onDismissError: () => void;
}

const LocationSortButton = ({ onClick, isLoading, error, onDismissError }: LocationSortButtonProps) => (
  <>
    <S.LocationButton onClick={onClick} disabled={isLoading}>
      <MyLocation size={18} />
      {isLoading ? 'Finner nærmeste senter...' : 'Sorter etter nærmeste senter'}
    </S.LocationButton>
    {error && (
      <UserInteraction
        maxWidth={600}
        title={error}
        variant={UserInteractionVariant.Warning}
        button={{
          onClick: onDismissError,
          children: 'Lukk',
          type: 'button',
        }}
      />
    )}
  </>
);

export default LocationSortButton;
